module.exports = __webpack_public_path__ + "static/bentonsanscond-bold-webfont-58f1b255922b10b54e0848f522271c86.woff";